import { ApolloClient, InMemoryCache } from '@apollo/client';

const BACK_END = process.env.REACT_APP_BACKEND_URL || window.env.BACKEND_URL;
const BACKEND_FRONTSHOP_URL = `${BACK_END}/frontshop`;

export const client = new ApolloClient({
  uri: BACKEND_FRONTSHOP_URL,
  cache: new InMemoryCache(),
});
